import {SponsorType} from '../../_types/selectOptionsTypes/SponsorType';

export const sponsorTypeOptions: Array<SponsorType> = [
  {value: 'COMPANY', label: 'Company'},
  {value: 'INDIVIDUAL', label: 'Individual'},
];
